import React from 'react';
import clsx from 'clsx';
import { createPopper } from '../../../utils/popperUtils';
import { ThreeDots } from '@td-client-frontend/icons';
import { useClickOutside } from '@td-client-frontend/common';

export interface DropdownOptions {
  label: string;
  onClick: () => void;
}

interface DropdownProps {
  label?: string;
  options: DropdownOptions[];
}

export const Dropdown = ({ label = '', options }: DropdownProps) => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef<HTMLButtonElement>();
  const popoverDropdownRef = React.createRef<HTMLDivElement>();
  const dropdownWrapper = React.createRef<HTMLDivElement>();

  const toggleDropdownPopover = () => {
    if (!dropdownPopoverShow) {
      createPopper(btnDropdownRef.current, popoverDropdownRef.current, { placement: 'bottom' });
    }
    setDropdownPopoverShow(!dropdownPopoverShow);
  };

  useClickOutside(dropdownWrapper, () => {
    setDropdownPopoverShow(false);
  });

  return (
    <div className="flex flex-wrap" data-testid="manage-member" ref={dropdownWrapper}>
      <button type="button" ref={btnDropdownRef} onClick={toggleDropdownPopover}>
        {label}
        <ThreeDots aria-hidden="true" title="Toggle menu" />
      </button>

      <div
        ref={popoverDropdownRef}
        data-testid="manage-member-drop-down"
        className={clsx(
          dropdownPopoverShow ? 'block' : 'hidden',
          'border-primary-500 border rounded flex text-base mt-3 z-40 list-none text-left shadow-lg justify-center flex-col bg-white w-28'
        )}
      >
        {options.map(({ label, onClick }: { label: string; onClick: () => void }, buttonIndex) => {
          return (
            <button
              key={label}
              onClick={onClick}
              className={clsx(
                'p-2 text-left',
                buttonIndex > 0 && 'border-t-1 border-gray-20',
                buttonIndex === 2 && 'bg-primary-30'
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
